export default __webpack_public_path__ + "static/media/icon-failed.df8eddf6.svg";